const BASE_LINK = 'https://res.cloudinary.com/cashflowfrog-com/image/upload';

export const getResponsiveImageLink = (imagePath, maxWidth, minWidth) => {
	if (typeof window !== 'undefined') {
		const screenWidth = typeof window !== 'undefined' && window.innerWidth;
		const width = !maxWidth || screenWidth < maxWidth ? screenWidth : maxWidth;
		// w_${width < minWidth ? minWidth : width},q_100,c_scale/
		return `${BASE_LINK}/${imagePath}`;
	} else return `${BASE_LINK}/${imagePath}`;
};
